import { ReportGroup } from '@/api/generatedApi';
import { ThumbnailContainer } from '@/components/ThumbnailPreview/ThumbnailPreview';
import { Box } from '@mui/material';
import { ThumbnailSize } from './ReportSample.styles';

export const GroupThumbnails = ({ group }: { group: ReportGroup }) => (
  <Box
    display='flex'
    flexDirection='row'
    gap='6px'
    sx={{ minWidth: 0, flexWrap: 'wrap', minHeight: `${ThumbnailSize}px` }}
  >
    {group.assetIds.slice(0, 3).map(assetId => (
      <ThumbnailContainer key={assetId} asset={{ id: assetId, tenantId: group.tenantId }} size={ThumbnailSize} />
    ))}
  </Box>
);
